/**
 * GraphQL Query
 * アカウント画面
 */

/**
 * アカウント一覧
 */
export const GRAPH_QL_QUERY_ACCOUNT_LIST =
`
  query {
    accounts ( ? ) {
      uuid
      account
      type
      siteRole {
        name
      }
      permissionRole {
        name
      }
    }
  }
`

/**
 * アカウント詳細
 */
export const GRAPH_QL_QUERY_ACCOUNT_DETAIL =
`
  query {
    account( ? ) {
      uuid
      account
      email
      isNotice
      type
      siteRole {
        uuid
        name
      }
      permissionRole {
        uuid
        name
        permissions {
          config {
            key
          }
          value
        }
      }
      timezone
      validIps
      isConsole
      updatedAt
    }
  }
`

/**
 * 対象ロールを使用しているアカウントの取得
 */
export const GRAPH_QL_QUERY_ACCOUNTS_USING_ROLE =
`
query {
  accountsUsingRole ( ? ) {
    type
  }
}
`
/**
 * 対象ロールを使用しているアカウントの取得
 */
export const GRAPH_QL_QUERY_ACCOUNTS_BY_ACCOUNT_NAME =
`
query {
  accountsByAccountName ( ? ) {
    account
  }
}
`
